import React, { useEffect, useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useParams } from 'react-router-dom';
import axiosInstance from '../config/axiosConfig';

const CandidatesPdf = () => {
    const { company_id, candidate_id, attempt_ref } = useParams();
    const [pdfUrl, setPdfUrl] = useState(null);

    useEffect(() => {

        const fetchPdf = async () => {
            try {
                const response = await axiosInstance({
                    url: `/dashboard/candidates/${company_id}/${candidate_id}/${attempt_ref}/generateCandidatePdf`,
                    method: 'POST',
                    responseType: 'blob',
                });

                if (response.headers['content-type'] !== 'application/pdf') {
                    console.error('Expected PDF, but received:', response.headers['content-type']);
                    return;
                }

                const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

                const pdfUrl = window.URL.createObjectURL(pdfBlob);

                setPdfUrl(pdfUrl);
            } catch (error) {
                console.error("Error fetching PDF:", error);
            }
        };


        fetchPdf();
    }, [company_id, candidate_id, attempt_ref]);

    return (
        <div className="is-flex is-flex-direction-column is-align-items-center justify-content" style={{ height: '100vh' }}>
            {pdfUrl ? (
                <iframe src={pdfUrl} width="100%" height="100%" title="Candidate PDF" />
            ) : (
                <>
                    <ProgressSpinner />
                    <p>Chargement du PDF ...</p>
                </>
            )}
        </div>
    );
};

export default CandidatesPdf;